import { forwardRef, JSXElementConstructor, ReactElement } from "react";
import { Dialog, Slide, Toolbar, AppBar, IconButton } from "@material-ui/core";
import CloseIcon from "@material-ui/icons/Close";
import { makeStyles } from "@material-ui/core";
import ReactHtmlParser from "react-html-parser";
import { CustomFullScreenDialogProps } from "../../../../@types/components/dialogProps.types";

import "./customFullScreenDialog.css";
import { TransitionProps } from "@material-ui/core/transitions";

// eslint-disable-next-line arrow-parens
const useStyles = makeStyles((theme) => ({
	appBar: {
		position: "relative",
		backgroundColor: "#3A4652"
	},
	title: {
		marginLeft: theme.spacing(2),
		flex: 1
	}
}));

const Transition: any = forwardRef(function Transition(props, ref) {
	return <Slide direction="up" ref={ref} {...props} />;
});

const CustomFullScreenDialog = ({ dialogProps }: CustomFullScreenDialogProps): JSX.Element => {
	const classes = useStyles();
	const { openDialog, title, content, handleCloseCallback, isParsed } = dialogProps;

	return (
		<div>
			<Dialog style={{ zIndex: 5000 }} fullScreen open={openDialog} TransitionComponent={Transition}>
				<AppBar className={classes.appBar + " app-bar"}>
					<Toolbar>
						<IconButton edge="start" color="inherit" aria-label="close" onClick={handleCloseCallback}>
							<CloseIcon />
						</IconButton>
						<div className="title">{title}</div>
					</Toolbar>
				</AppBar>
				<div className="content">{isParsed ? <>{content}</> : <>{ReactHtmlParser(content)}</>}</div>
			</Dialog>
		</div>
	);
};

export default CustomFullScreenDialog;
